import React from "react";
import Button from "../../components/v2/Button";
import {useTranslation} from "react-i18next";

export default function ChooseServiceItem(
    {
        item,
        itemSelectedHandler,
    }
) {

    const {t} = useTranslation('common');

    return (
        <div
            className="flex rounded-2xl bg-gradient-to-b from-black/50 to-black/0 w-full max-w-[640px] p-2 gap-[16px] flex-col border-white/20 border-[3px]">
            <div className="flex">
                <div className="flex justify-center items-center">
                    <img src={item.icon} className={"min-w-[86px] min-h-[86px] max-w-[86px] max-h-[86px]"}/>
                </div>
                <div className="flex flex-grow px-2 gap-1 flex-col">
                    <div className="text-lg tracking-[2px]"><b>{item.title}</b></div>
                    <div className="text-sm">{item.description}</div>
                </div>
            </div>
            <div><Button text={t('service.step_choose_service.order_label')}
                         clickHandler={(e) => itemSelectedHandler(item)}/></div>
        </div>
    );
}
